import React, { useContext, useState } from 'react';
import alertContext from '../context/alerts/alertContext';
import noteContext from '../context/notes/noteContext';

const AddNote = () => {
    const context = useContext(noteContext);

    const noteInitial = {title: "", description: "", tag: "General"};
    const [note, setNote] = useState(noteInitial);

    const contextAlert = useContext(alertContext);
    const { showAlert } = contextAlert;

    const handleClick = (e)=>{
        e.preventDefault();
        try {
            if(addNote(note.title, note.description, note.tag)){
                showAlert("Note addded successfully", "success");
            }
            else{
                showAlert("Some error occurred. Please try again later.", "danger");
            }
            setNote(noteInitial);
        } catch (error) {
            showAlert("Some error occurred. Please try again later after some time.", "danger")
        }
    }
    
    const onChange = (e)=>{
        setNote({...note, [e.target.name]: e.target.value});
    }

    const { addNote } = context;
    return (
        <div className="container my-3">
            <h2>Add Note</h2>
            <form>
                <div className="mb-3">
                    <label htmlFor="title" className="form-label">Title</label>
                    <input type="text" className="form-control" id="title" name="title"aria-describedby="emailHelp" onChange={onChange} value={note.title} minLength={1} required/>
                </div>
                <div className="mb-3">
                    <label htmlFor="description" className="form-label">Description</label>
                    <input type="text" className="form-control" id="description" name="description" onChange={onChange}value={note.description} minLength={1} required/>
                </div>
                <div className="mb-3">
                    <label htmlFor="tag" className="form-label">Tag</label>
                    <input type="text" className="form-control" id="tag" name="tag" onChange={onChange} value={note.tag} />
                </div>
                
                <button disabled={note.title.length<1 || note.description.length<1} type="submit" className="btn btn-primary" onClick={handleClick}>Add Note</button>
            </form>
        </div>
    )
}

export default AddNote
